import { LicenseMonthlySubscriptionSubFormController } from '../controller/LicenseMonthlySubscriptionSubFormController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { LicenseSubFormComponent } from '../../types/LicenseSubFormComponent';
import { CompanyActionContext } from '../../../company/common/types/CompanyActionContext';
import { LicenseMainFormViewData } from '../../licenseMainForm/types/LicenseMainFormViewData';
import { CompanyType } from '../../../company/types/company-type';
import { combineLatest, Observable } from 'rxjs';
import { CompanyData } from '../../../company/types/company-data';
import { DeepPartial } from 'typeorm';
import { map } from 'rxjs/operators';

export class LicenseMonthlySubscriptionSubFormWebComponent
  extends BaseWebComponentElement
  implements LicenseSubFormComponent
{
  public controller!: LicenseMonthlySubscriptionSubFormController;
  public context: CompanyActionContext;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LicenseMonthlySubscriptionSubFormController,
    });
  }

  public get valid$(): Observable<boolean> {
    return combineLatest([
      this.controller.view.formGroup.valid$,
      this.controller.view.dom.$ownUseProductTypeFormField.valid$,
      this.controller.view.dom.$resellBundleForm.valid,
    ]).pipe(
      map(([formGroupValid, ownUseProductTypeValid, resellBundleFormValid]) => {
        return formGroupValid && ownUseProductTypeValid && resellBundleFormValid;
      })
    );
  }

  public get value() {
    return this.controller.view.getFormValue();
  }

  public setCompanyType(companyType: CompanyType) {
    if (!this.started) {
      return;
    }

    this.controller.setCompanyType(companyType, false);
  }

  public setCanBeManagedByAbove(canBeManagedByAbove: boolean) {
    if (!this.started) {
      return;
    }

    this.controller.setCanBeManagedByAbove(canBeManagedByAbove);
  }

  public setCompanyData(company: CompanyData): void {
    this.controller.setCompanyData(company);
  }

  public setSubscriptionDetails(company: DeepPartial<CompanyData>) {
    this.controller.view.setSubscriptionDetails(company);
  }

  public setViewData(viewData: LicenseMainFormViewData) {
    this.context = viewData.context;
    this.controller.setViewData(viewData);
  }
}
